






















































































import { Component, Vue } from 'vue-property-decorator'
import MallConfig from '@/api/mall/mallConfig/index'
import PicModal from '@/components/upload/picModal.vue'
import RewardPointProductSelect from '@/components/reward-point-product-select/index.vue'
import SelectUrl from '@/components/selectUrl/index.vue'
@Component({
  components: {
    PicModal,
    RewardPointProductSelect,
    SelectUrl
  }
})
export default class Carousel extends Vue {
  banners: any[] = [
    {
      pictureUrl: '',
      link: '',
      displayOrder: 1
    }
  ]
  mounted() {
    this.load()
  }
  load() {
    MallConfig.getMallConfig('VipCenterCarouselConfig').then(res => {
      if (res.data) {
        this.banners = res.data.json
      }
    })
  }
  picChange(index, e) {
    console.log(e)
    this.banners[index].pictureUrl = e[0].url
  }
  up(index: number) {
    var item = this.banners.splice(index, 1)
    this.banners.splice(index - 1, 0, ...item)
  }
  down(index: number) {
    var item = this.banners.splice(index, 1)
    this.banners.splice(index + 1, 0, ...item)
  }
  remove(index: number) {
    this.banners.splice(index, 1)
  }

  add() {
    let obj = {
      pictureUrl: '',
      linkType: 0,
      link: '',
      displayOrder: 1
    }
    this.banners.push(obj)
  }
  save() {
    //判断图片是否为空
    var count = this.banners.filter(t => t.pictureUrl === '').length
    if (count === 0) {
      MallConfig.updateMallConfig(
        'VipCenterCarouselConfig',
        '会员中心轮播图设置',
        { json: this.banners }
      ).then(res => {
        this.$Notice.success({
          desc: '保存成功'
        })
        // this.$Message.success('保存成功')
      })
    } else {
      this.$Message.warning('请选择图片')
    }
  }

  urlChange(e, index) {
    this.banners[index].link = e
  }
}
